var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('action-dialog-popup',_vm._b({attrs:{"action":_vm.action},on:{"actionComplete":_vm.completeAction,"actionTerminate":_vm.terminateAction}},'action-dialog-popup',_vm.$props,false))}
var staticRenderFns = []

export { render, staticRenderFns }